<template>
  <li ref="versionItem">
    <span v-if="mustClip" class="popup">{{ value }}</span>
    <span v-if="value" ref="valueText">{{ printValue }}</span>
    <v-progress-circular v-else indeterminate size="16" :width="2" class="version-loader"/>
  </li>
</template>

<script>
  const TRIM_LENGTH = 25;

  export default {
    props: ['value', 'invalidate'],
    data() {
      return {
        mustClip: false
      };
    },
    computed: {
      printValue() {
        return this.mustClip ? `${this.value.substr(0, TRIM_LENGTH)}...` : this.value;
      }
    },
    watch: {
      value() {
        this.$nextTick(this.setMustClip);
      }
    },
    methods: {
      setMustClip() {
        if (this.value) {
          this.mustClip = this.value.length > TRIM_LENGTH + 3;
        } else {
          this.mustClip = false;
        }
      }
    },
    mounted() {
      this.setMustClip();
    }
  };
</script>

<style lang="less" scoped>
  @import '../../../../style/variables.less';

  li {
    white-space: nowrap;

    .version-loader {
      color: @edval-dark;
    }

    > .popup {
      display: none;
      position: fixed;
      background: #ffffff;
    }

    &:hover > .popup {
      display: initial;
    }
  }
</style>
